import axios from "axios";
import { AMAZON_CAMPAIGN_ENDPOINTS2 } from "../../../utils/constant";
import { slidersValue } from "../../../utils/interfaces";

export const generateResponse = async (campaignId :string , agentId: string, targetCommentId: string, responseSliderValues: slidersValue, userMessage:string, conversation_tree: Object )=>{

    const response = await axios.post(`${AMAZON_CAMPAIGN_ENDPOINTS2}/generate-response/${campaignId}/${agentId}/${targetCommentId}`, 
    {
        "user_choices":
        {"length": "one paragraph",
        "tone": "logical",
        "formality": "casual",
        "targetAudiencePolitics": "progressive",
        userMessage: userMessage
        },
        "conversation_tree": conversation_tree
    }
 
    );

    return response.data.content
}